import { createFileRoute } from '@tanstack/react-router';
import { AdminFeaturesScreen } from '@/features/admin/AdminFeaturesScreen';

/** Admin, Features: each section's stage and the open early access
 *  requests (docs/ACCESS.md). */
export const Route = createFileRoute('/_app/admin/features')({
  component: AdminFeaturesScreen,
});
